import React from 'react';
import cn from 'classnames';
import classes from './Toggle.module.css';
import CheckMark from '@assets/images/Fireboard/CheckMark';

const TogglePill = ({ labels, selected, onToggle }) => {
  return (
    <div
      className={cn(classes.pillWrapper, 'pb-0')}
      onClick={() => onToggle(!selected)}
    >
      <div className={cn(classes.pill, { [classes.selected]: selected })}>
        <div className={classes.checkContainer}>
          <CheckMark />
        </div>
        <span className={classes.pillText}>
          {selected ? labels[1] : labels[0]}
        </span>
      </div>
    </div>
  );
};

export default TogglePill;
